import React from 'react';
import PropTypes from 'prop-types';
import { decodeSpecialChars } from '@/lib/StringUtils';


function ListItem ({ video, insertVideoToEditor, closeModal }) {
  const { id, title, imageUrl } = video;
  const decodedTitle = decodeSpecialChars(title);

  return (
    <li>
      <a href="#" onClick={handleItemClick} className="link_item">
        <span className="thumb_item">
          <img src={imageUrl} alt={decodedTitle} />
        </span>
        <span className="cont_item">{decodedTitle}</span>
      </a>
    </li>
  );

  function handleItemClick () {
    insertVideoToEditor(id);
    closeModal();
  }
}

ListItem.propTypes = {
  video: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    imageUrl: PropTypes.string,
  }),
  insertVideoToEditor: PropTypes.func,
  closeModal: PropTypes.func,
};

export default ListItem;
